import { IApplicationState } from '../../types/redux';
import { ESearchBlockView } from '../../types/searchBlockView';
import { ESearchBlockViewActionType, TSearchBlockViewActions } from '../../actions/searchBlockView';

export function searchBlockViewReducer(
  state: IApplicationState['searchBlockView'] = ESearchBlockView.SearchString,
  action: TSearchBlockViewActions,
): IApplicationState['searchBlockView'] {
  switch (action.type) {
    case ESearchBlockViewActionType.SetSearchBlockView:
      return action.payload;
    default:
      return state;
  }
}
